import _defineProperty from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { useState, useRef, useCallback } from 'react';
import isEqual from 'fast-deep-equal';
import { filterErrors } from './filter-errors/filter-errors.js';
import { clearListState } from './clear-list-state/clear-list-state.js';
import { shouldValidateOnChange } from './validate/should-validate-on-change.js';
import { setPath } from './paths/set-path.js';
import { validateFieldValue } from './validate/validate-field-value.js';
import { reorderPath } from './paths/reorder-path.js';
import { removePath } from './paths/remove-path.js';
import { insertPath } from './paths/insert-path.js';
import { validateValues } from './validate/validate-values.js';
import { getStatus } from './get-status/get-status.js';
import { getPath } from './paths/get-path.js';
import { getInputOnChange } from './get-input-on-change/get-input-on-change.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function useForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$initialValues = _ref.initialValues,
    initialValues = _ref$initialValues === void 0 ? {} : _ref$initialValues,
    _ref$initialErrors = _ref.initialErrors,
    initialErrors = _ref$initialErrors === void 0 ? {} : _ref$initialErrors,
    _ref$initialDirty = _ref.initialDirty,
    initialDirty = _ref$initialDirty === void 0 ? {} : _ref$initialDirty,
    _ref$initialTouched = _ref.initialTouched,
    initialTouched = _ref$initialTouched === void 0 ? {} : _ref$initialTouched,
    _ref$clearInputErrorO = _ref.clearInputErrorOnChange,
    clearInputErrorOnChange = _ref$clearInputErrorO === void 0 ? true : _ref$clearInputErrorO,
    _ref$validateInputOnC = _ref.validateInputOnChange,
    validateInputOnChange = _ref$validateInputOnC === void 0 ? false : _ref$validateInputOnC,
    _ref$validateInputOnB = _ref.validateInputOnBlur,
    validateInputOnBlur = _ref$validateInputOnB === void 0 ? false : _ref$validateInputOnB,
    _ref$transformValues = _ref.transformValues,
    transformValues = _ref$transformValues === void 0 ? function (values) {
      return values;
    } : _ref$transformValues,
    rules = _ref.validate;
  var _useState = useState(initialTouched),
    _useState2 = _slicedToArray(_useState, 2),
    touched = _useState2[0],
    setTouched = _useState2[1];
  var _useState3 = useState(initialDirty),
    _useState4 = _slicedToArray(_useState3, 2),
    dirty = _useState4[0],
    setDirty = _useState4[1];
  var _useState5 = useState(initialValues),
    _useState6 = _slicedToArray(_useState5, 2),
    values = _useState6[0],
    _setValues = _useState6[1];
  var _useState7 = useState(filterErrors(initialErrors)),
    _useState8 = _slicedToArray(_useState7, 2),
    errors = _useState8[0],
    _setErrors = _useState8[1];
  var _dirtyValues = useRef(initialValues);
  var _setDirtyValues = function _setDirtyValues(_values) {
    _dirtyValues.current = _values;
  };
  var resetTouched = useCallback(function () {
    return setTouched({});
  }, []);
  var resetDirty = function resetDirty(_values) {
    _setDirtyValues(_values || values);
    setDirty({});
  };
  var setErrors = useCallback(function (errs) {
    return _setErrors(function (current) {
      return filterErrors(typeof errs === "function" ? errs(current) : errs);
    });
  }, []);
  var clearErrors = useCallback(function () {
    return _setErrors({});
  }, []);
  var reset = useCallback(function () {
    _setValues(initialValues);
    clearErrors();
    resetDirty(initialValues);
    resetTouched();
  }, []);
  var setFieldError = useCallback(function (path, error) {
    return setErrors(function (current) {
      return __spreadProps(__spreadValues({}, current), _defineProperty({}, path, error));
    });
  }, []);
  var clearFieldError = useCallback(function (path) {
    return setErrors(function (current) {
      if (typeof path !== "string") {
        return current;
      }
      var clone = __spreadValues({}, current);
      delete clone[path];
      return clone;
    });
  }, []);
  var clearFieldDirty = useCallback(function (path) {
    return setDirty(function (current) {
      if (typeof path !== "string") {
        return current;
      }
      var result = clearListState(path, current);
      delete result[path];
      return result;
    });
  }, []);
  var setFieldValue = useCallback(function (path, value) {
    var shouldValidate = shouldValidateOnChange(path, validateInputOnChange);
    clearFieldDirty(path);
    setTouched(function (currentTouched) {
      return __spreadProps(__spreadValues({}, currentTouched), _defineProperty({}, path, true));
    });
    _setValues(function (current) {
      var result = setPath(path, value, current);
      if (shouldValidate) {
        var validationResults = validateFieldValue(path, rules, result);
        validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
      }
      return result;
    });
    !shouldValidate && clearInputErrorOnChange && setFieldError(path, null);
  }, []);
  var setValues = useCallback(function (payload) {
    _setValues(function (currentValues) {
      var valuesPartial = typeof payload === "function" ? payload(currentValues) : payload;
      return __spreadValues(__spreadValues({}, currentValues), valuesPartial);
    });
    clearInputErrorOnChange && clearErrors();
  }, []);
  var reorderListItem = useCallback(function (path, payload) {
    clearFieldDirty(path);
    _setValues(function (current) {
      return reorderPath(path, payload, current);
    });
  }, []);
  var removeListItem = useCallback(function (path, index) {
    clearFieldDirty(path);
    _setValues(function (current) {
      return removePath(path, index, current);
    });
    _setErrors(function (errs) {
      return clearListState(path, errs);
    });
  }, []);
  var insertListItem = useCallback(function (path, item, index) {
    clearFieldDirty(path);
    _setValues(function (current) {
      return insertPath(path, item, index, current);
    });
  }, []);
  var validate = useCallback(function () {
    var results = validateValues(rules, values);
    _setErrors(results.errors);
    return results;
  }, [values, rules]);
  var validateField = useCallback(function (path) {
    var results = validateFieldValue(path, rules, values);
    results.hasError ? setFieldError(path, results.error) : clearFieldError(path);
    return results;
  }, [values, rules]);
  var getInputProps = function getInputProps(path) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "input" : _ref2$type,
      _ref2$withError = _ref2.withError,
      withError = _ref2$withError === void 0 ? true : _ref2$withError,
      _ref2$withFocus = _ref2.withFocus,
      withFocus = _ref2$withFocus === void 0 ? true : _ref2$withFocus;
    var onChange = getInputOnChange(function (value) {
      return setFieldValue(path, value);
    });
    var payload = {
      onChange: onChange
    };
    if (withError) {
      payload.error = errors[path];
    }
    if (type === "checkbox") {
      payload.checked = getPath(path, values);
    } else {
      payload.value = getPath(path, values);
    }
    if (withFocus) {
      payload.onFocus = function () {
        return setTouched(function (current) {
          return __spreadProps(__spreadValues({}, current), _defineProperty({}, path, true));
        });
      };
      payload.onBlur = function () {
        if (shouldValidateOnChange(path, validateInputOnBlur)) {
          var validationResults = validateFieldValue(path, rules, values);
          validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
        }
      };
    }
    return payload;
  };
  var onSubmit = function onSubmit(handleSubmit, handleValidationFailure) {
    return function (event) {
      event == null ? void 0 : event.preventDefault();
      var results = validate();
      if (results.hasErrors) {
        handleValidationFailure == null ? void 0 : handleValidationFailure(results.errors, values, event);
      } else {
        handleSubmit == null ? void 0 : handleSubmit(transformValues(values), event);
      }
    };
  };
  var getTransformedValues = function getTransformedValues(input) {
    return transformValues(input || values);
  };
  var onReset = useCallback(function (event) {
    event.preventDefault();
    reset();
  }, []);
  var isDirty = function isDirty(path) {
    if (path) {
      var overriddenValue = getPath(path, dirty);
      if (typeof overriddenValue === "boolean") {
        return overriddenValue;
      }
      var sliceOfValues = getPath(path, values);
      var sliceOfInitialValues = getPath(path, _dirtyValues.current);
      return !isEqual(sliceOfValues, sliceOfInitialValues);
    }
    var isOverridden = Object.keys(dirty).length > 0;
    if (isOverridden) {
      return getStatus(dirty);
    }
    return !isEqual(values, _dirtyValues.current);
  };
  var isTouched = useCallback(function (path) {
    return getStatus(touched, path);
  }, [touched]);
  var isValid = useCallback(function (path) {
    return path ? !validateFieldValue(path, rules, values).hasError : !validateValues(rules, values).hasErrors;
  }, [values, rules]);
  return {
    values: values,
    errors: errors,
    setValues: setValues,
    setErrors: setErrors,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    clearFieldError: clearFieldError,
    clearErrors: clearErrors,
    reset: reset,
    validate: validate,
    validateField: validateField,
    reorderListItem: reorderListItem,
    removeListItem: removeListItem,
    insertListItem: insertListItem,
    getInputProps: getInputProps,
    onSubmit: onSubmit,
    onReset: onReset,
    isDirty: isDirty,
    isTouched: isTouched,
    setTouched: setTouched,
    setDirty: setDirty,
    resetTouched: resetTouched,
    resetDirty: resetDirty,
    isValid: isValid,
    getTransformedValues: getTransformedValues
  };
}
export { useForm };